<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <h1 class="heading">Bitte verifizieren Sie Ihre Handynummer</h1>

      <p class="info-text">
        Ein Verifizierungscode wird an die
        angegebene&nbsp;Handynummer&nbsp;gesendet.
      </p>

      <form [formGroup]="form">
        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'Handynummer'"
            [formControlName]="'phoneNumber'"
            [error]="form.controls.phoneNumber.invalid && showError"
            [errorMessage]="'Bitte geben Sie eine gültige Handynummer ein'"
            [inputMode]="'tel'"
            [autoComplete]="'tel'"
            [inputType]="'tel'"
            [showContent]="true"
            [errorIcon]="'assets/icon/icon_error.svg'"
            ><zaver-select-country
              [buttonId]="'select-country-code'"
              [items]="AVAILABLECOUNTRYCODES"
              (itemSelected)="setCountry($event)"
              [selectedItem]="selectedCountry"
            ></zaver-select-country>
          </zaver-animated-form-input>
        </div>
      </form>

      <div class="footer-wrapper">
        <div class="button-container">
          <zaver-primary-button
            [text]="'Weiter'"
            [disabled]="navigationInProgress"
            (click)="handleCtaClick()"
          ></zaver-primary-button>
        </div>
      </div>
    </div>
  </div>
</div>
